<script setup lang="js">
const props=defineProps({title:String})
</script>

<template>
  <div class="text-3xl md:text-3xl lg:text-[1.8rem] my-4 md:my-4 lg:my-6 ">{{title}}</div>
</template>

<style scoped>

</style>
